import Image from "next/image";
import Head from "next/head";
import styles from "../our-faculty/faculty-list.module.css";
import redright from "../../assets/images/contact/redrightarrow.png";
import nagarajan from "../../assets/images/faculty/visiting-faculty/nagarajan.webp";
import rameshkumarkhanna from "../../assets/images/faculty/visiting-faculty/ramesh-kumar-khanna.webp";
import devasahayam from "../../assets/images/faculty/visiting-faculty/devasahayam.webp";
import ramiah from "../../assets/images/faculty/visiting-faculty/ramiah.webp";
import nareshgupta from "../../assets/images/faculty/visiting-faculty/naresh-gupta.webp";
import sreenivasan from "../../assets/images/faculty/visiting-faculty/sreenivasan.webp";
import ananthachari from "../../assets/images/faculty/visiting-faculty/ananthachari.webp";
import hormistharakan from "../../assets/images/faculty/visiting-faculty/hormis-tharakan.webp";
import rathakrishnan from "../../assets/images/faculty/visiting-faculty/rathakrishnan.webp";
import sanjayarora from "../../assets/images/faculty/visiting-faculty/sanjay-arora.webp";
import dogra from "../../assets/images/faculty/visiting-faculty/dogra.webp";
import sylaendrababu from "../../assets/images/faculty/visiting-faculty/sylaendra-babu.webp";
import ravi from "../../assets/images/faculty/visiting-faculty/ravi.webp";
import jayanthmurali from "../../assets/images/faculty/visiting-faculty/jayanth-murali.webp";
import manjunatha from "../../assets/images/faculty/visiting-faculty/manjunatha.webp";
import baghyadevi from "../../assets/images/faculty/visiting-faculty/baghya-devi.webp";
import sarangi from "../../assets/images/faculty/visiting-faculty/sarangi.webp";
import stephenmervinalexander from "../../assets/images/faculty/visiting-faculty/stephen-mervin-alexander.webp";
import ravindhran from "../../assets/images/faculty/visiting-faculty/ravindhran.webp";
import rahulkbhonsle from "../../assets/images/faculty/visiting-faculty/rahul-k-bhonsle.webp";
import theodarebaskaran from "../../assets/images/faculty/visiting-faculty/theodare-baskaran.webp";
import upadhyoy from "../../assets/images/faculty/visiting-faculty/upadhyoy.webp";
import vasan from "../../assets/images/faculty/visiting-faculty/vasan.webp";
import palanisamy from "../../assets/images/faculty/visiting-faculty/palanisamy.webp";
import shrigautamdey from "../../assets/images/faculty/visiting-faculty/shri-gautam-dey.webp";
import ramkumar from "../../assets/images/faculty/visiting-faculty/ram-kumar.webp";
import ramkhanthojha from "../../assets/images/faculty/visiting-faculty/ram-khanth-ojha.webp";
import AshutoshSamantSinghar from "../../assets/images/faculty/visiting-faculty/Ashutosh-Samant-Singhar.webp";
import thilagaraj from "../../assets/images/faculty/visiting-faculty/thilagaraj.webp";
import UthamKumarJamadhagni from "../../assets/images/faculty/visiting-faculty/Utham-Kumar-Jamadhagni.webp";
import muraleedharan from "../../assets/images/faculty/visiting-faculty/muraleedharan.webp";
import sutharsanpathmanaban from "../../assets/images/faculty/visiting-faculty/sutharsan-pathmanaban.webp";
import miriamsamuel from "../../assets/images/faculty/visiting-faculty/miriam-samuel.webp";
import sureshbabu from "../../assets/images/faculty/visiting-faculty/suresh-babu.webp";
import selvaraj from "../../assets/images/faculty/visiting-faculty/selvaraj.webp";
import sultanahmedismail from "../../assets/images/faculty/visiting-faculty/sultan-ahmed-ismail.webp";
import venkataraman from "../../assets/images/faculty/visiting-faculty/venkataraman.webp";
import srikantaswamy from "../../assets/images/faculty/visiting-faculty/srikantaswamy.webp";
import vijayamohanan from "../../assets/images/faculty/visiting-faculty/vijayamohanan.webp";
import suresh from "../../assets/images/faculty/visiting-faculty/suresh.webp";
import sangeethamenon from "../../assets/images/faculty/visiting-faculty/sangeetha-menon.webp";
import suryanarayanan from "../../assets/images/faculty/visiting-faculty/suryanarayanan.webp";
import ganapathy from "../../assets/images/faculty/visiting-faculty/ganapathy.webp";
import venkatachalam from "../../assets/images/faculty/visiting-faculty/venkatachalam.webp";
import gopalappa from "../../assets/images/faculty/visiting-faculty/gopalappa.webp";
import belagali2 from "../../assets/images/faculty/visiting-faculty/belagali-2.webp";
import manivannan from "../../assets/images/faculty/visiting-faculty/manivannan.webp";
import abulfaiz from "../../assets/images/faculty/visiting-faculty/abul-faiz.webp";
import muralidharan from "../../assets/images/faculty/visiting-faculty/muralidharan.webp";
import nagalsamy from "../../assets/images/faculty/visiting-faculty/nagalsamy.webp";
import gopal from "../../assets/images/faculty/visiting-faculty/gopal.webp";
import deepalansaju from "../../assets/images/faculty/visiting-faculty/deepalan-saju.webp";
import ramasubramanyam from "../../assets/images/faculty/visiting-faculty/ramasubramanyam.webp";
import gunasekaran from "../../assets/images/faculty/visiting-faculty/gunasekaran.webp";
import kavithamuralidharan from "../../assets/images/faculty/visiting-faculty/kavitha-muralidharan.webp";
import muralidharankasiviswanathan from "../../assets/images/faculty/visiting-faculty/muralidharan-kasiviswanathan.webp";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";

const Faculty = () => {
 
  return (
    <>
        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Visiting Faculty / Panel Members - Shankar IAS Academy</title>
            <meta name="title" content="Visiting Faculty / Panel Members - Shankar IAS Academy" />
            <meta name="description" content="" />
            <link rel="canonical" href="https://www.shankariasacademy.com/visiting-faculty-panel-members/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Visiting Faculty / Panel Members - Shankar IAS Academy" />
            <meta property="og:description" content="" />
            <meta property="og:url" content="https://www.shankariasacademy.com/visiting-faculty-panel-members/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

      <Navbar title="about" />
      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>Our Faculty Team</h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3  align-items-baseline`}
            >
              <Link href="/our-faculty">
                <button
                  id={styles.tablinks}
                  className="nav-link tab1 py-2 px-0 me-4"
                  type="button"
                >
                  UPSC Faculties
                </button>
              </Link>
              <Link href="/visiting-faculty-panel-members">
                <button
                  id={styles.tablinks}
                  className="nav-link tab2 py-2 px-0 me-4 active"
                  type="button"
                >
                  UPSC - Visiting UPSC Faculties
                </button>
              </Link>
              <Link href="/tnpsc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  type="button"
                >
                  TNPSC Faculties
                </button>
              </Link>
              <Link href="/bankingssc-faculty-list">
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  type="button"
                >
                  Banking & SSC Faculties
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
            <div className="row">
              {/* <!-- Shri A. Nagarajan, I.A.S. --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={nagarajan}
                      alt="Shri A. Nagarajan, I.A.S."
                      className="img-fluid"
                      title="Shri A. Nagarajan, I.A.S."
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri A. Nagarajan, I.A.S.
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal1"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri A. Nagarajan, I.A.S. Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal1"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri A. Nagarajan, I.A.S.
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He served as a Special Chief Secretary and Development
                        Commissioner to the Government of Tamilnadu. During his
                        career span, Shri Nagarajan was associated with various
                        institutions/Government Bodies/Corporations interalia
                        housing & Urban Development Department, Tamilnadu
                        Powerfin Development Corporation Ltd., Tamilnadu
                        Industrial Investment Corporation Ltd. He served as a
                        Special Commissioner of Treasuries & Accounts, Member
                        Secretary of State Planning Commission, Additional
                        secretary, Industries - Government of Tamilnadu,
                        Commissioner - Regional Provident Fund, Chennai,
                        Executive Director of National seeds Corporation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Ramesh Kumar Khanna, I.A.S. --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={rameshkumarkhanna}
                      alt="Shri Ramesh Kumar Khanna, I.A.S"
                      className="img-fluid"
                      title="Shri Ramesh Kumar Khanna, I.A.S"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Ramesh Kumar Khanna, I.A.S.
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal2"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Ramesh Kumar Khanna, I.A.S. Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal2"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Ramesh Kumar Khanna, I.A.S.
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        An Indian Administrative Service (Retired) officer with
                        rich experience of over 32 years in administration and
                        management and known for efficiency, planning,
                        coordinating and monitoring capabilities. Retired as
                        Additional Chief Secretary, Government of Tamil Nadu.
                        His Diverse educational qualifications and experiences
                        boasted him with Strong knowledge and experience in
                        Project Management and handling of Public Private
                        Partnership, Skill Development, Social and Industrial
                        sector projects.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri M.G.Devasahayam I.A.S --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={devasahayam}
                      alt="Shri M.G.Devasahayam, I.A.S "
                      className="img-fluid"
                      title="Shri M.G.Devasahayam I.A.S"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri M.G.Devasahayam, I.A.S
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal3"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri M.G.Devasahayam I.A.S Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal3"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri M.G.Devasahayam, I.A.S
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Economist cum Administrator with a
                        distinguished career spanning 40 years, with direct and
                        first-hand experience in the working and ethos of Indian
                        Army, Civil Services, Government, Public & Private
                        Sector, Political system as well as NGOs. He is a
                        dynamic thinker, analyst and writer. Several of his
                        articles have been published in Newspapers across the
                        Country and prestigious publications. The thrust in his
                        writing has been Reforms, Resource Efficiency and Good
                        Governance as well as topics like Freedom, Democracy and
                        Corruption. He has also made presentations on many of
                        these subjects in National and International Seminars.
                        Shri Devasahayam was given special assignment as Member
                        of Government of India’s High Power Committee on
                        Agricultural Policies and Programmes that went into the
                        issue of “transforming Agriculture into an Industry”. He
                        had the privilege of writing the theme chapter of the
                        Report, contents of which has been influencing
                        Agriculture development policies of successive
                        Governments at the Centre.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. P. A. Ramiah, IAS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ramiah}
                      alt="Dr. P. A. Ramiah, IAS"
                      className="img-fluid"
                      title="Dr. P. A. Ramiah, IAS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. P. A. Ramiah, IAS
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Former Chairman,
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Teachers Recruitment Board (TRB)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal4"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. P. A. Ramiah, IAS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal4"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. P. A. Ramiah, IAS
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        Former Chairman,
                      </p>
                      <p className={`${styles.checkboxcontent} mb-0`}>
                        Teachers Recruitment Board (TRB)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an officer of the Indian Administrative Service,
                        earned a doctoral degree in Child Labour, Dr. Ramiah has
                        taken a lot of initiatives in improving the performance
                        of students in Secondary and Higher Secondary Board
                        Examinations during his tenure as the Secretary,
                        Government of Tamil Nadu. Besides this, while holding
                        several administrative positions like Additional
                        District Collector, District Collector, Secretary to
                        Government in Charge of Tamil Development and Culture
                        etc., he followed all the possible means to devote
                        himself in perking up the quality of Education.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Naresh Gupta IAS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={nareshgupta}
                      alt="Shri Naresh Gupta IAS"
                      className="img-fluid"
                      title="Shri Naresh Gupta IAS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Naresh Gupta, IAS
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal5"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Naresh Gupta IAS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal5"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Naresh Gupta, IAS
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        An 1973 batch IAS officer allotted to Tamil Nadu Cadre.
                        He held important posts including that of Secretary to
                        Governor, Home Secretary and Public Secretary. He was
                        the Chief Electoral Officer, Tamil Nadu. After
                        retirement, he also served as Member, Central
                        Administrative Tribunal. He is an avid writer and his
                        books include, he has written three books – (1)
                        Electoral Systems & Process in India; (2) The Path to
                        Salvation published by Bharatiya Vidya Bhavan & (3)
                        Democracy & Human Development in India published by the
                        Publications Division, GOI.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri T.P. Sreenivasan IFS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sreenivasan}
                      alt="Shri T.P. Sreenivasan IFS"
                      className="img-fluid"
                      title="Shri T.P. Sreenivasan IFS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri T.P. Sreenivasan, IFS
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal6"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri T.P. Sreenivasan IFS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal6"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri T.P. Sreenivasan, IFS
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He has served in the foreign service for 37 years. A
                        former Ambassador of India he is currently executive
                        Vice-Chairman, Kerala State Higher Education Council,
                        and Director General, Kerala International Centre. T.P.
                        Sreenivasan is a former Permanent Representative of
                        India to the United Nations and Governor for India of
                        the International Atomic Energy Agency and Ambassador to
                        Austria and Slovenia He has nearly 20 years of
                        experience in multilateral diplomacy and has represented
                        India at a number of international conferences organised
                        by the United Nations, the Commonwealth and the
                        Nonaligned Movement. He has chaired several UN
                        Committees and Conferences.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri T. Ananthachari IPS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ananthachari}
                      alt="Shri T. Ananthachari IPS"
                      className="img-fluid"
                      title="Shri T. Ananthachari IPS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri T. Ananthachari, IPS
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal7"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri T. Ananthachari IPS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal7"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri T. Ananthachari, IPS
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Former Director-General, Border Security Force,
                        Government of India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri P. K. Hormis Tharakan IPS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={hormistharakan}
                      alt="Shri P. K. Hormis Tharakan IPS"
                      className="img-fluid"
                      title="Shri P. K. Hormis Tharakan IPS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri P. K. Hormis Tharakan, IPS
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal8"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri P. K. Hormis Tharakan IPS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal8"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri P. K. Hormis Tharakan, IPS
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Indian Police Service officer of the Kerala
                        cadre and was chief of the Research and Analysis Wing
                        (R&AW), India&apos;s external intelligence agency, He
                        was also the former Director General of the Kerala
                        Police. His Excellence include him as one of the
                        advisors to the governor of Karnataka, when the state
                        was brought under the President&apos;s rule prior to
                        Assembly elections in the state in 2008. He was a member
                        of the National Security Council and was also the Chief
                        Advisor of Strategic Affairs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. K. Radhakrishnan IPS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={rathakrishnan}
                      alt="Dr. K. Radhakrishnan IPS"
                      className="img-fluid"
                      title="Dr. K. Radhakrishnan IPS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. K. Radhakrishnan, IPS
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal9"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. K. Radhakrishnan IPS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal9"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. K. Radhakrishnan, IPS
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Indian Police Service Officer of the batch of
                        1983, belonging to the Tamil Nadu Cadre. Currently, he
                        is serving as the Director General of Police of the
                        Civil Supplies, CID department of Tamil Nadu. Dr. K.
                        Radhakrishnan also holds a PhD from the Department of
                        Criminology from the University of Madras for seminal
                        research on ‘Tactical and Strategic Police Response to
                        Communal Violence: Coimbatore, a case study’, awarded by
                        the University of Madras. He received many awards which
                        also include the President&apos;s medal for
                        &quot;Meritorious Service&quot;. He received the Queen’s
                        Award for Innovation in Police Training and Development
                        in 2002 and 2004 and is the only officer from all of
                        Commonwealth Nations to have won the distinguished
                        bi-annual award consecutively.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Sanjay Arora IPS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sanjayarora}
                      alt="Shri Sanjay Arora IPS"
                      className="img-fluid"
                      title="Shri Sanjay Arora IPS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Sanjay Arora, IPS
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal10"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                          src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Sanjay Arora IPS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal10"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Sanjay Arora, IPS
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an officer of Tamil Nadu 1988 batch who is
                        presently posted as ADGP Administration. He was
                        Superintendent of Police (SP), Special Task Force,
                        Sathyamangalam,. He was on deputation with the
                        Indo-Tibetian Border Police before becoming the
                        Commissioner of Police, Coimbatore city . He was Deputy
                        Inspector-General of Police, Villupuram Range, and was
                        Deputy Director of Vigilance and Anti-Corruption before
                        becoming IG, Railways
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri S K Dogra IPS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={dogra}
                      alt="Shri S K Dogra IPS"
                      className="img-fluid"
                      title="Shri S K Dogra IPS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri S K Dogra, IPS
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>Former DGP</p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal11"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri S K Dogra IPS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal11"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri S K Dogra, IPS
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>Former DGP</p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Retired police officer (IPS, retired). Author, trainer,
                        motivator. Human Resource & Security Advisor to a
                        well-known group of companies. He has served in
                        different capacities in various parts of Tamil Nadu .
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. C. Sylendra Babu IPS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sylaendrababu}
                      alt="Dr. C. Sylendra Babu IPS"
                      className="img-fluid"
                      title="Dr. C. Sylendra Babu IPS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. C. Sylendra Babu, IPS
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal12"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. C. Sylendra Babu IPS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal12"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. C. Sylendra Babu, IPS
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Indian Police Service Officer of the 1987 batch
                        belonging to the Tamil Nadu cadre. He is serving as the
                        Additional Director General of Police of the Coastal
                        Security Group, Tamil Nadu. He holds a PhD in
                        Criminology from the University of Madras. He holds a
                        Bachelor of Science in Agriculture degree from the
                        Agricultural College and Research Institute, Madurai and
                        majored in agriculture from the Tamil Nadu Agricultural
                        University, Coimbatore. Later, he obtained a Bachelor of
                        General Law and Master of Arts in Population Studies
                        from the Annamalai University and was awarded a PhD for
                        his thesis on &quot;missing children&quot; by the
                        University of Madras. In 2013, he obtained a Master of
                        Business Administration degree in Human Resources.
                        Currently, he is pursuing a course in computer science
                        and cyber crime investigation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri M Ravi I.P.S --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ravi}
                      alt="Shri M Ravi I.P.S"
                      className="img-fluid"
                      title="Shri M Ravi I.P.S"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri M Ravi, I.P.S
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal13"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri M Ravi I.P.S Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal13"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri M Ravi, I.P.S
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Additional director General of Police\Chief
                        Vigilance Officer of Aavin, his stints in various posts
                        he held and served made him among the awardees of
                        President’s Police Medal for distinguished service.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri K. Jayanth Murali I.P.S --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={jayanthmurali}
                      alt="Shri K. Jayanth Murali I.P.S"
                      className="img-fluid"
                      title="Shri K. Jayanth Murali I.P.S"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri K. Jayanth Murali, I.P.S
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal14"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri K. Jayanth Murali I.P.S Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal14"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri K. Jayanth Murali, I.P.S
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is currently posted as ADGP, Traffic Planning Cell
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Manjunatha IPS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={manjunatha}
                      alt="Shri Manjunatha IPS"
                      className="img-fluid"
                      title="Shri Manjunatha IPS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Manjunatha, IPS
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal15"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Manjunatha IPS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal15"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Manjunatha, IPS
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        A 1991-batch IPS officer, Shri Manjunatha served as
                        Superintendent of Police of Dharmapuri and Villupuram
                        districts, besides as SP, Security Branch CID, and
                        Vigilance and Anti-Corruption. He served as Deputy
                        Inspector General of Police of Coimbatore Range and had
                        been Commissioner of Police, Tirunelveli City.
                        Consequent to his promotion as Inspector General of
                        Police, Shri Manjunatha served as IG, Crime Branch CID
                        and IG North Zone. Presently he is posted as ADGP.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Smt.  R.Bhagya Devi I.R.S --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={baghyadevi}
                      alt="Smt.  R.Bhagya Devi I.R.S"
                      className="img-fluid"
                      title="Smt.  R.Bhagya Devi I.R.S"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Smt. R.Bhagya Devi, I.R.S
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Commissioner of Central Excise
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal16"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Smt.  R.Bhagya Devi I.R.S Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal16"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Smt. R.Bhagya Devi, I.R.S
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>
                        Commissioner of Central Excise
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri P.K. Sarangi I.R.S --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sarangi}
                      alt="Shri P.K. Sarangi I.R.S"
                      className="img-fluid"
                      title="Shri P.K. Sarangi I.R.S"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri P.K. Sarangi, I.R.S
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal17"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri P.K. Sarangi I.R.S Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal17"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri P.K. Sarangi, I.R.S
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an 1973 batch officer, he is the Former Director
                        General in Income Tax department.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Stephen Mervin Alexander --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={stephenmervinalexander}
                      alt="Shri Stephen Mervin Alexander"
                      className="img-fluid"
                      title="Shri Stephen Mervin Alexander"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Stephen Mervin Alexander
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>(PMG,CCR)</p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal18"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Stephen Mervin Alexander Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal18"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Stephen Mervin Alexander
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>(PMG,CCR)</p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        An Indian Postal Service (IPoS) Officer of 1987 batch,
                        is currently the Joint Secretary, in Dept. of Atomic
                        Energy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri K M Ravindran IIS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ravindhran}
                      alt="Shri K M Ravindran IIS"
                      className="img-fluid"
                      title="Shri K M Ravindran IIS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri K M Ravindran, IIS
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Addl. Director General Press Information Bureau
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      (Southern Region)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal19"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri K M Ravindran IIS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal19"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri K M Ravindran, IIS
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        Addl. Director General Press Information Bureau
                      </p>
                      <p className={`${styles.checkboxcontent} mb-0`}>
                        (Southern Region)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He belongs to the 1986 batch of Indian Information
                        Service (IIS). He began his career in Doordarshan, New
                        Delhi, and held various positions from News Editor to
                        Director level. he is also working as the Special
                        Correspondent of the All India Radio for Sri Lanka and
                        Maldives
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Brigadier Rahul K Bhonsle --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={rahulkbhonsle}
                      alt="Brigadier Rahul K Bhonsle"
                      className="img-fluid"
                      title="Brigadier Rahul K Bhonsle"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Brigadier Rahul K Bhonsle,
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal20"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Brigadier Rahul K Bhonsle Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal20"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Brigadier Rahul K Bhonsle,
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Indian army military veteran with 30 years
                        active field experience in counter militancy and
                        terrorism operations. Post retirement since 2006, he has
                        combined his military expertise with extensive study of
                        future trends in conflict to build a personal repertoire
                        of workshops, seminars, books, magazine and newspaper
                        articles which are internationally acknowledged. He is
                        presently Director of Asia Security-Risks.com, a South
                        Asian security risk and knowledge management consultancy
                        which specializes in future scenarios, military capacity
                        building and conflict trends in South Asia. He has
                        worked on the entire gamut of issues related
                        international security to include an overall assessment
                        of nontraditional security threats to India
                        conceptualised in, “Asymmetrical Challenges to India’s
                        National Security”. “Securing India: Assessment of
                        Defence and Security Capabilities,” outlines defence
                        modernisation strategies for India. His recent works
                        relate to terrorism include, “Beyond Bin Laden: Global
                        Terrorism Scenarios,” & “Countering Transnational
                        Terrorism,”. A number of recommendations from these
                        books have been incorporated in government policy on
                        counter terrorism in India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Theodore Baskaran --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={theodarebaskaran}
                      alt="Shri Theodore Baskaran "
                      className="img-fluid"
                      title="Shri Theodore Baskaran"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Theodore Baskaran,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal21"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Theodore Baskaran Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal21"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Theodore Baskaran,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank}`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Theodore Baskaran, a film historian, began his career in
                        Tamilnadu Archives and then entered civil service in
                        Indian Postal Service as Divisional Superintendent and
                        served as the &quot;Special Officer For War
                        Efforts&quot; in Shillong during the Indo-Pakistan War
                        of 1971. His book won the Golden Lotus award from the
                        President of India. Baskaran was a member of the
                        Advisory Board of National Film Archives. He taught a
                        course on Tamil Cinema in the University of Michigan.
                        His Stint in cinema made him the jury for National film
                        awards. Baskaran has lectured on cinema in Western
                        Australian National University, Princeton and University
                        of Chicago. He is a graduate of the National Defense
                        College.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Commodore R.S. Vasan --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={upadhyoy}
                      alt="Commodore R.S. Vasan"
                      className="img-fluid"
                      title="Commodore R.S. Vasan"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Commodore R.S. Vasan,
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal22"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Commodore R.S. Vasan Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal22"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Commodore R.S. Vasan,
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He has a distinguished military service of over 34
                        years. His shore assignments include command of two
                        naval air stations, maritime air squadron, Air Crew
                        Examiner, member of the faculty at the College of Naval
                        warfare and Chief Staff Officer of the Southern Naval
                        Command at Kochin, India. Prior to his retirement he was
                        the Regional Commander of the Eastern Region of the
                        Indian Coast Guard. Presently he is steering the
                        Maritime Security Programme at the Observer Research
                        Foundation a major Indian think tank and also is Head of
                        Strategy and Security Studies, Centre for Asia Studies,
                        Chennai.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri R K Upadhyay IFoS  --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={vasan}
                      alt="Shri R K Upadhyay IFoS"
                      className="img-fluid"
                      title="Shri R K Upadhyay IFoS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri R K Upadhyay, IFoS{" "}
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Principal Chief Conservator of Forests (Research &
                      Education)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal23"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri R K Upadhyay IFoS  Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal23"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri R K Upadhyay, IFoS{" "}
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        Principal Chief Conservator of Forests (Research &
                        Education)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Palanisamy IIS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={palanisamy}
                      alt="Shri Palanisamy IIS"
                      className="img-fluid"
                      title="Shri Palanisamy IIS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Palanisamy, IIS{" "}
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                    (Director, All India Radio)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal24"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Palanisamy IIS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal24"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Palanisamy, IIS
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        Director (All India Radio)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Gautham Dey I.Fo.S --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={shrigautamdey}
                      alt="Shri Gautham Dey I.Fo.S"
                      className="img-fluid"
                      title="Shri Gautham Dey I.Fo.S"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Gautham Dey, I.Fo.S
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal25"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Gautham Dey I.Fo.S Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal25"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Gautham Dey, I.Fo.S
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Former Principal Chief Conservator of Forests (Head of
                        Forest Force)
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Ramkumar IFoS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ramkumar}
                      alt="Shri Ramkumar IFoS"
                      className="img-fluid"
                      title="Shri Ramkumar IFoS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Ramkumar, IFoS
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal26"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Ramkumar IFoS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal26"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Ramkumar, IFoS
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He was a Former Principal Chief Conservator Of Forests
                        Deputed To The Tamil Nadu Magnesite Limited as Its
                        Chairman-Cum-Managing Director.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Rama Kant Ojha IFS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ramkhanthojha}
                      alt="Shri Rama Kant Ojha IFS"
                      className="img-fluid"
                      title="Shri Rama Kant Ojha IFS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Rama Kant Ojha, IFS
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal27"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Rama Kant Ojha IFS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal27"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Rama Kant Ojha, IFS
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He was a Former Principal Chief Conservator Of Forests
                        (Research And Education)
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Ashutosh Samant Singhar IFS -->  */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={AshutoshSamantSinghar}
                      alt="Shri Ashutosh Samant Singhar IFS"
                      className="img-fluid"
                      title="Shri Ashutosh Samant Singhar IFS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Ashutosh Samant Singhar, IFS
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal28"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Ashutosh Samant Singhar IFS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal28"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Ashutosh Samant Singhar, IFS
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He was a Former Additional principle Chief Conservator
                        of Forests and posted as Joint Managing Director, Tamil
                        Nadu Tea Plantation Corporation Limited.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. R. Thilagaraj  Ph.D --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={thilagaraj}
                      alt="Dr. R. Thilagaraj  Ph.D"
                      className="img-fluid"
                      title="Dr. R. Thilagaraj  Ph.D"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. R. Thilagaraj, Ph.D
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Former Director Centre for Cyber Forensics & Information
                      Security, University of Madras
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal29"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. R. Thilagaraj  Ph.D Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal29"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. R. Thilagaraj, Ph.D
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <p className={`${styles.checkboxcontent} mb-0`}>
                        Former Director Centre for Cyber Forensics & Information
                        Security, University of Madras
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Former Professor & Head Department of Criminology,
                        University of Madras, Chennai and had specialized in
                        Psychology of Crime and Delinquency ,Research
                        Methodology and he is also Vice President, International
                        Society of Criminological Psychology, Mexico. He has
                        published various articles in the spectrum of
                        criminology and he has also written books on Human
                        Rights and Criminal Justice Administration, Crime in
                        railways, Social deviance and victimization of children,
                        Goal behavior of delinquents.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. Utham Kumar Jamadhagni --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={UthamKumarJamadhagni}
                      alt="Dr. Utham Kumar Jamadhagni"
                      className="img-fluid"
                      title="Dr. Utham Kumar Jamadhagni"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. Utham Kumar Jamadhagni
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal30"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. Utham Kumar Jamadhagni Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal30"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. Utham Kumar Jamadhagni
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Associate Professor & Head of Department of Defence and
                        Strategic Studies with his Interests and specialization
                        in International Relations, Maritime Security, Conflict
                        Analysis/Non-Traditional Security. He has published a
                        book on&quot; The Unrecognised Peril: Threats to
                        Environmental Security&quot;.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Muraleedhran VR --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={muraleedharan}
                      alt="Shri Muraleedhran VR"
                      className="img-fluid"
                      title="Shri Muraleedhran VR"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Muraleedhran, VR
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal31"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Muraleedhran VR Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal31"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Muraleedhran, VR
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is currently Professor of Economics , Indian
                        Institute of Technology (Madras) He has his post
                        doctoral exposure and research in Takemi Fellow in
                        International Health, Harvard School of Public Health,
                        Boston (USA), Rockefeller Foundation Research Fellowship
                        in History of Malaria, Rockefeller Archive Center (New
                        York) he is also South Asia Visiting Scholar, Center for
                        International Development, Queen Elizabeth House,
                        University of Oxford and he has his research interests
                        in Healthcare economics, History of Healthcare in India
                        and Environmental Health Policy which helped him to
                        serve as a Member of the Mission Steering Group of the
                        National Rural Health Mission (Govt of India). He has
                        also served as member of sub-groups on Health, Planning
                        Commission of India and currently he is also co-Vice
                        President of the Health Economics Association of India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Sudarsan Padmanabhan --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sutharsanpathmanaban}
                      alt="Shri Sudarsan Padmanabhan"
                      className="img-fluid"
                      title="Shri Sudarsan Padmanabhan"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Sudarsan Padmanabhan,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Department of Humanities and Social Sciences, Indian
                      Institute of Technology)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal32"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Sudarsan Padmanabhan Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal32"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Sudarsan Padmanabhan,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Department of Humanities and Social Sciences, Indian
                        Institute of Technology)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He received his PhD from University of South Florida and
                        worked at Kenyon College, Ohio, USA, before joining the
                        Department of Humanities and Social Sciences, Indian
                        Institute of Technology, Madras. He specializes in
                        social and political philosophy, and Indian philosophy
                        and culture. His research interest lies in the
                        confluence of law, democracy, and ethics in the public
                        sphere. He has published in these domains in various
                        journals and edited volumes including the Routledge
                        Handbook of Cosmopolitanism Studies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Smt. K. Miriam Samuel --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={miriamsamuel}
                      alt="Smt. K. Miriam Samuel"
                      className="img-fluid"
                      title="Smt. K. Miriam Samuel"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Smt. K. Miriam Samuel
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal33"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Smt. K. Miriam Samuel Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal33"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Smt. K. Miriam Samuel
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        She is currently the Head of the Department of Social
                        Work and has specialization in Psychiatric Social Work,
                        International Social Work and Gender studies with her
                        field of research in Gender Issues, Community Health and
                        Disasters and social work with her achievement in
                        Establishing the centre for International Social Work.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Suresh Babu M --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sureshbabu}
                      alt="Shri Suresh Babu M"
                      className="img-fluid"
                      title="Shri Suresh Babu M"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Suresh Babu M
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal34"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Suresh Babu M Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal34"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Suresh Babu M
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Associate Professor Dept. of Humanities and Social
                        Sciences and his profound areas of Areas of Research are
                        Applied Macroeconomics, Industrial Economics, Trade and
                        Development. he was a Member WTO Forum on
                        non-agricultural sector, Government of Kerala and also
                        Consultant for the Asian Development Bank for
                        identifying “Growth Potentials in Kerala’s Industrial
                        Sector” . he is also undergoing projects on Monitoring
                        Sarva Siksha Abhayan in Tamil Nadu, Productivity and
                        Efficiency of Manufacturing Enterprises in the
                        Unorganized Sector, ICSSR, Micro and Small Enterprises
                        and Innovation: Issues and Challenges, Trade
                        Liberalization and Employment: Evidence from Indian
                        Industry Economic Reforms, Industrial Structure
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. Selvaraj --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={selvaraj}
                      alt="Dr. Selvaraj"
                      className="img-fluid"
                      title="Dr. Selvaraj"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. Selvaraj
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal35"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. Selvaraj Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal35"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. Selvaraj
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is retired professor and Head, Department of
                        Economics in Madras Christian College with 36 years of
                        teaching experience to his credit. During his
                        illustrious carrier, he acquired wide-spread knowledge
                        on research by undertaking various research projects
                        focused on Women Development for “The Tamil Nadu
                        Corporation for Development of Women, Government of
                        Tamil Nadu” and also for other reputed corporate
                        institutes. He also served as Consultant Economists for
                        several projects sponsored by World Bank. With keen
                        interest on research, he was enrolled as a research
                        supervisor recognized by University of Madras for M.Phil
                        and Ph.D scholars. He was mentor for many projects of
                        Government of India, Centre for Entrepreneurial and
                        Economic Development and Madras Christian College. He
                        executed his academic and administration support as a
                        Member of Board of Studies, Member of Academic council
                        and Member of Ph.D Doctoral committee. Since 1988,
                        Selvaraj was enthroned with administrative positions
                        served as a co-ordinator, Dean, Chairman,
                        Vice-president, and Director for several departments and
                        colleges. He has worked extensively on his major
                        publications for “Macro Economics, NCERT, “Mastering
                        Economics” and “Consumer Price Index”.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Sultan Ahmed Ismail --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sultanahmedismail}
                      alt="Shri Sultan Ahmed Ismail"
                      className="img-fluid"
                      title="Shri Sultan Ahmed Ismail"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Sultan Ahmed Ismail
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal36"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Sultan Ahmed Ismail Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal36"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Sultan Ahmed Ismail
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Eminent Indian Soil Biologist and Ecologist. He
                        has published 65 papers in National and International
                        Journals & Proceedings also He is honored with a D.Sc.
                        in Zoology from the University of Madras in 2001 for his
                        research in the field of Soil Ecology –Earthworms –
                        Waste Management He is also the Managing Director of Eco
                        science Research Foundation. He is father of
                        vermiculture.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr M. Venkataraman --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={venkataraman}
                      alt="Dr M. Venkataraman"
                      className="img-fluid"
                      title="Dr M. Venkataraman"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr M. Venkataraman
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal37"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr M. Venkataraman Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal37"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr M. Venkataraman
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He was Associate Professor in Addis Ababa University,
                        Ethiopia. At present he is Assistant Professor,
                        Department of Defence and Strategic Studies, and his
                        research interests are mainly on systemic and nation
                        state’s concerns of security and foreign policy
                        elaborations. He follows eclectic methodology and
                        triangulation of analysis and interpretations. He is
                        comparative with respect to issues of Africa and
                        Southeast Asia with particular focus on China.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- DR S. Srikantaswamy --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={srikantaswamy}
                      alt="DR S. Srikantaswamy"
                      className="img-fluid"
                      title="DR S. Srikantaswamy"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        DR S. Srikantaswamy,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal38"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- DR S. Srikantaswamy Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal38"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          DR S. Srikantaswamy,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is Associate Professor in the department of
                        Environmental Science and His research interest lies in
                        Environmental Science, (Environmental EarthScience)
                        Biomaterials, Nanomaterials Carbon nanotubes).
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- N. Vijayamohanan Pillai Ph. D. --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={vijayamohanan}
                      alt="N. Vijayamohanan Pillai Ph. D"
                      className="img-fluid"
                      title="N. Vijayamohanan Pillai Ph. D"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        N. Vijayamohanan Pillai, Ph. D.
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal39"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- N. Vijayamohanan Pillai Ph. D. Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal39"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          N. Vijayamohanan Pillai, Ph. D.
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Associate Professor at Centre for Development
                        Studies (CDS) Trivandrum. He is a well-known scholar in
                        Econometrics, Marxian Economics and Mathematical
                        Economics and his field of research interests are Energy
                        Economics, Applied Statistics and Development Studies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr Suresh R --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={suresh}
                      alt="Dr Suresh R"
                      className="img-fluid"
                      title="Dr Suresh R"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr Suresh R
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal40"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr Suresh R Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal40"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr Suresh R
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is an Associate Professor, Department of Political
                        Science, University of Kerala, He had published Four
                        Books and has also published research articles in
                        reputed national and International Journals. He is
                        working on a UGC Major Research Project ‘Maritime
                        Security of India: The Coastal Security Challenges and
                        Policy Options’. He has been selected as Associate in
                        the Indian Institute of Advanced Study, Shimla and is
                        working on the project titled The Tibetan Issue and
                        India - China Border Problem; A Security Perspective. He
                        is the Hon. Director of the prestigious V K Krishna
                        Menon Study Centre for International Relations,
                        Thiruvanathapuram.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Smt. Sangeetha Menon Ph.D. --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={sangeethamenon}
                      alt="Smt. Sangeetha Menon Ph.D."
                      className="img-fluid"
                      title="Smt. Sangeetha Menon Ph.D."
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Smt. Sangeetha Menon, Ph.D.
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal41"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Smt. Sangeetha Menon Ph.D. Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal41"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Smt. Sangeetha Menon, Ph.D.
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        She is a Professor at the National Institute of Advanced
                        Studies, in the Indian Institute of Science and joined
                        NIAS in 1996, with particular interest in consciousness
                        studies in the larger context of
                        science-spirituality-art interface issues. She is a
                        philosopher-psychologist. Professor Sangeetha Menon has
                        been working in Consciousness Studies for over eighteen
                        years. Her core research interests are Indian ways of
                        thinking in classical philosophical schools, Indian
                        psychology and Indian dramaturgy, and current
                        discussions on consciousness. She has received national
                        awards for her achievements in the field of
                        consciousness and Indian contributions. She also
                        received the Young Philosopher Award from the Indian
                        Council of Philosophical Research, for her research
                        work.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. V. Suryanarayan --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={suryanarayanan}
                      alt="Dr. V. Suryanarayan"
                      className="img-fluid"
                      title="Dr. V. Suryanarayan"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. V. Suryanarayan
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal42"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. V. Suryanarayan Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal42"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. V. Suryanarayan,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He was the Senior Professor and founding Director,
                        Centre for South and Southeast Asian Studies, University
                        of Madras. He is associated with two think tanks in
                        Chennai, the Center for Asia Studies and the Chennai
                        Centre for China Studies. Prof. Suryanarayan is one of
                        India&apos;s leading specialists in South and Southeast
                        Asian Studies and combines in his teaching and research
                        specialization in history, political science and
                        international relation&apos;s He was a visiting
                        Professor at the Department of History, University of
                        California, Los Angeles; Columbus College, University
                        System of Georgia; School of International Studies,
                        Jawaharlal Nehru University, New Delhi; Peradeniya
                        University, Sri Lanka.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr.G.P.Ganapathy --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ganapathy}
                      alt="Dr.G.P.Ganapathy"
                      className="img-fluid"
                      title="Dr.G.P.Ganapathy"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr.G.P.Ganapathy
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal43"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr.G.P.Ganapathy Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal43"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr.G.P.Ganapathy
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is completed his Doctoral Research in Earthquake
                        Microzonation for Chennai City at Anna University,
                        Chennai. He served for Centre for Disaster Mitigation
                        and Management, Anna University, Chennai for 8 years as
                        a Scientist and carried out research studies the field
                        of earthquake hazard assessment, earthquake monitoring,
                        seismic micro-Zonation, landslide hazard Zonation, Soil
                        Bio Engineering for Slope Stabilization, environment
                        impact assessment and management. Dr. Ganapathy
                        presented more than 50 research papers in reputed
                        International/National journals, workshops and
                        conferences and he is Managing Editor and Editorial
                        Board Member for 13 International Journals. Dr.
                        Ganapathy is the member for the State Disaster
                        Management Plan Core group, consultant for preparation
                        of district level multi disaster plan, Government of
                        Tamil Nadu. He is the honorary member in the Joint
                        Working Group for Geotechnical Disaster Management and
                        member in many scientific societies. He is the nominated
                        member for the creation of Disaster loss database for
                        Tamil Nadu State by UNOPS, Geneva. Dr.Ganapathy is
                        invited member of the Working Committee on Landslide
                        Hazard Mitigation, formulated by the National Disaster
                        Management Authority, Government of India. He also
                        contributed to the Global Assessment Report 2011 on
                        Disaster Risk Reduction. He offered technical support in
                        two major publications published by Government of India
                        viz. Seismic Micro-Zonation methodology, Landslide
                        Hazard Zonation Atlas of India. His ongoing funded
                        research projects are Development of Early warning
                        System for shallow landslides, funded by ISRO, and
                        Updating the loss database for the state of Tamil Nadu
                        funded by UN-ISDR, Geneva.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Prof. L.Venkatachalam --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={venkatachalam}
                      alt="Prof. L.Venkatachalam"
                      className="img-fluid"
                      title="Prof. L.Venkatachalam"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Prof. L.Venkatachalam
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal44"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Prof. L.Venkatachalam Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal44"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Prof. L.Venkatachalam
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is a Professor. He is Visiting Fellow, Environmental
                        Economics and Natural Resources Group, Wageningen
                        University, the Netherlands. Visiting Fellow, University
                        of British Columbia, Vancouver, Canada. Visiting Fellow,
                        Cornell University, Ithaca, United States of America, He
                        has been a visiting faculty at the Indian Institute of
                        Technology, Madras School of Economics (MSE) and Indian
                        Maritime University, Chennai. He works on environmental
                        economics with a focus on non-market valuation,
                        environmental policy and climate change. He has held
                        Fulbright-Nehru Senior Research Fellowship, Indo-French
                        Scholars’ Exchange Fellowship and Indo-Canadian Faculty
                        Research Fellowship and won the Japanese Award for his
                        outstanding Research on Development.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri D.V.Gopalappa --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={gopalappa}
                      alt="Shri D.V.Gopalappa"
                      className="img-fluid"
                      title="Shri D.V.Gopalappa"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri D.V.Gopalappa
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal45"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri D.V.Gopalappa Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal45"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri D.V.Gopalappa
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He has worked in various capacities at Institute for
                        Social and Economic Change, Bangalore. Currently, he is
                        Professor in the Economics at University of Mysore with
                        his Area of Specialization in Development Economics and
                        Rural Development, PRIs, Watershed, Credit, Agriculture,
                        Sericulture. He has a number of Publications in referred
                        journals to his credit. he has been specializing in
                        Rural Development and Regional Planning. He has been
                        involved in researching more than half a dozen sponsored
                        research projects on issued of contemporary issue
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. S.L.Belagali --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={belagali2}
                      alt="Dr. S.L.Belagali"
                      className="img-fluid"
                      title="Dr. S.L.Belagali"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. S.L.Belagali,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      (Former UPSC Interview board Member)
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal46"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. S.L.Belagali Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal46"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. S.L.Belagali,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        (Former UPSC Interview board Member)
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He joined as a Professor & Co-coordinator to
                        Environmental Science department of Mysore University.
                        He also worked as the Chairman of Environmental Science
                        department of Mysore University. He completed six
                        research projects for Mangalore University, Minnesota
                        University USA, ISRO, Bangalore, Ministry of Environment
                        & Forests, New Delhi, Philips Electronics India Limited
                        Gurgoan and University grants commission, New Delhi. He
                        also worked as BOE, BOS, BOA member/Chairman of Mysore
                        University & other Universities in Karnataka & other
                        States. He is a member of Selection Committee for NCERT,
                        CFTRI etc. staff. He was also the Academic Council
                        member of Mysore University for two years. He has
                        carried out the confidential works for Orissa Public
                        Service Commission, UGC, UPSC etc. He is a member of UGC
                        assessment committees. He is also a Local Sectional
                        Secretary of Environmental Science for Indian Science
                        Congress meeting to be held in January 2016 at Mysore
                        University, Mysore.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. R. Manivannan --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={manivannan}
                      alt="Dr. R. Manivannan"
                      className="img-fluid"
                      title="Dr. R. Manivannan"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. R. Manivannan
                      </span>
                    </p>
                    <p className={`${styles.checkboxcontent} mb-0`}>
                      Professor & Head Department of Politics and Public
                      Administration University of Madras
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal47"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. R. Manivannan Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal47"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. R. Manivannan
                        </span>
                      </p>
                      <p className={`${styles.checkboxcontent} mb-0`}>
                        Professor & Head Department of Politics and Public
                        Administration University of Madras
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is a passionate research scholar who has chaired many
                        a seminar and contributed a lot to the field of research
                        and education. He was known especially for his
                        prodigious publication of a book which talks about the
                        genocidal attacks that aimed at ethnic cleansing of the
                        Sri Lankan Tamils from Eelam. His eloquence on Tamil
                        Eelam tragedy attracted the attention of UN council to
                        deliberate the gravity of the problems.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Prof. N. Abul Faiz --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={abulfaiz}
                      alt="Prof. N. Abul Faiz"
                      className="img-fluid"
                      title="Prof. N. Abul Faiz"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Prof. N. Abul Faiz,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Head of the Department, Dept. of Visual Communication
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal48"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Prof. N. Abul Faiz Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal48"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Prof. N. Abul Faiz,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        Head of the Department, Dept. of Visual Communication
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is also Founder and Director of AF School of News
                        Reading. He is an Advisor of few reputed and prestigious
                        colleges and schools of India and member of the board of
                        studies, Guest faculty in NIFT (National Institute of
                        Fashion Technology) and Visiting Faculty for Media
                        Courses of reputed colleges in India and is a Resource
                        Person for Personality Development & Effective
                        Communication Courses.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Dr. V. Muralidharan --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={muralidharan}
                      alt="Dr. V. Muralidharan"
                      className="img-fluid"
                      title="Dr. V. Muralidharan"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Dr. V. Muralidharan
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal49"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Dr. V. Muralidharan Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal49"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Dr. V. Muralidharan
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is currently the Associate Professor and Head
                        Department of Defence and Strategic Studies. His area of
                        Specialization includes National Security Studies. He is
                        the Associate Member of BODIES Institute For Defence
                        Studies And Analysis, New Delhi and also Member of
                        Evaluation Board of Many Academic Bodies Including
                        Jawaharlal Nehru University, New Delhi.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri S.Nagalsamy IAAS --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={nagalsamy}
                      alt="Shri S.Nagalsamy IAAS"
                      className="img-fluid"
                      title="Shri S.Nagalsamy IAAS"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri S.Nagalsamy, IAAS
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal50"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri S.Nagalsamy IAAS Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal50"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri S.Nagalsamy, IAAS
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He was a member of Tamil Nadu Electricity Regulatory
                        Commission and was Principal accountant general for
                        Tamil nadu and Pondicherry
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri E.Gopal --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={gopal}
                      alt="Shri E.Gopal"
                      className="img-fluid"
                      title="Shri E.Gopal"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri E.Gopal,
                      </span>{" "}
                      <span className={`${styles.checkboxcontent}`}>
                        (Retd.)
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal51"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri E.Gopal Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal51"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri E.Gopal,
                        </span>{" "}
                        <span className={`${styles.checkboxcontent}`}>
                          (Retd.)
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        Senior Sub Editor of The Hindu and practicing lawyer
                        post retirement. He is also working as Spl.
                        Correspondent for Asian Tribune, a web daily. He is the
                        president of The Hindu Newspaper Employees Union and
                        also the president of The Indo Sri Lankan Journalists
                        Friendship Association which exchanges journalist groups
                        between both nations. He had also served in various
                        government committees.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Deepalan Saju --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={deepalansaju}
                      alt="Shri Deepalan Saju"
                      className="img-fluid"
                      title="Shri Deepalan Saju"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Deepalan Saju,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      renowned environmentalist
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal52"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Deepalan Saju Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal52"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Deepalan Saju,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        renowned environmentalist
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Rama Subramaniyam --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={ramasubramanyam}
                      alt="Shri Rama Subramaniyam"
                      className="img-fluid"
                      title="Shri Rama Subramaniyam"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Rama Subramaniyam,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Renowned journalist in South Indian Media
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal53"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Rama Subramaniyam Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal53"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Rama Subramaniyam,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                      Renowned journalist in South Indian Media
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri M Gunasekaran --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={gunasekaran}
                      alt="Shri M Gunasekaran"
                      className="img-fluid"
                      title="Shri M Gunasekaran"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri M Gunasekaran,
                      </span>
                    </p>
                    <p className={`${styles.acheiverrank} mb-0`}>
                      Editor at News 18 TV
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal54"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri M Gunasekaran Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal54"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri M Gunasekaran,
                        </span>
                      </p>
                      <p className={`${styles.acheiverrank} mb-0`}>
                        Editor at News 18 TV
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Smt. Kavitha Muralidharan --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={kavithamuralidharan}
                      alt="Smt. Kavitha Muralidharan"
                      className="img-fluid"
                      title="Smt. Kavitha Muralidharan"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Smt. Kavitha Muralidharan
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal55"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Smt. Kavitha Muralidharan Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal55"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Smt. Kavitha Muralidharan
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        She is an Associate Editor of India Today and has
                        previously worked as Head of the Reporting Department at
                        the Hindu and Special Correspondent at Deccan Chronicle.
                        She has also worked at several other leading
                        publications including The Week, India Today and News
                        Today. She has covered important developments in
                        politics and other spheres in Tamil Nadu and has written
                        features on various issues including health, cinema,
                        literature, environment and human rights issues. Kavitha
                        is the winner of the Press Institute of India -
                        International Red Cross award for humanitarian reporting
                        in conflict situations for her coverage of the Sri Lanka
                        war. She has also authored several books in Tamil and
                        English.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Shri Muralidharan Kasi Viswanathan --> */}
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-3">
                <div className={`${styles.facultyborder3} h-100`}>
                  <div
                    className={`${styles.facultyboxheight} px-4 pt-4 pt-md-5 text-center`}
                  >
                    <Image
                      src={muralidharankasiviswanathan}
                      alt="Shri Muralidharan Kasi Viswanathan"
                      className="img-fluid"
                      title="Shri Muralidharan Kasi Viswanathan"
                    />
                    <p className="pt-3 mb-0">
                      <span className={`${styles.acheivername}`}>
                        Shri Muralidharan Kasi Viswanathan
                      </span>
                    </p>
                  </div>
                  <hr className="mb-0" />
                  <div className="px-4 pb-1 py-md-2">
                    <div
                      className="row"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#SubcriptionConfirmationModal56"
                    >
                      {/* <!-- <div > --> */}
                      <div className="col-9 align-self-center">
                        <p
                          className={`${styles.redunderline} mb-0`}
                          id={styles.directionline}
                        >
                          Know More
                        </p>
                      </div>
                      <div className="col-3">
                        <Image
                           src={redright}
                          className={`${styles.img} img-fluid`}
                          alt="arrow"
                          title="Link"
                        />
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Shri Muralidharan Kasi Viswanathan Modal --> */}
              <div
                className="modal fade px-2"
                id="SubcriptionConfirmationModal56"
                tabIndex={-1}
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className={`${styles.modalheaderborder} modal-header`}>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body p-4 p-md-5">
                      <p className="mb-0">
                        <span className={`${styles.acheivername}`}>
                          Shri Muralidharan Kasi Viswanathan,
                        </span>
                      </p>
                      <hr />
                      <p className={`${styles.acheiverrank}`}>
                        He is currently senior correspondent at BBC TAMIL.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <Footer />
    </>
  );
};

export default Faculty;
